import React from 'react'
import PropTypes from 'prop-types'
import { Conditional } from '@resurs/react-utils'
import styles from './styles.module.scss'

const DisabledOverlay = ({ disable, children }) => (
  <div className={styles.relative}>
    <Conditional when={disable}>
      <div className={styles.overlay} />
    </Conditional>
    {children}
  </div>
)

DisabledOverlay.propTypes = {
  disable: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

DisabledOverlay.defaultProps = {
  disable: false,
}

export default DisabledOverlay
